// extracted by mini-css-extract-plugin
module.exports = {"goods_container":"SortBootsPage_goods_container__2Ysim","goods_container__mobile":"SortBootsPage_goods_container__mobile__1kKyK"};